import { useMemo, useState } from 'react';
import { Button } from '@common-components';
import { useBoolean, useOptionsMenu } from 'hooks';
import { useGetRenewalDemoSteps } from 'broker/pages/SubmissionWorkspacePage/components/Header/RenewalDemo/useGetRenewalDemoSteps';
import { RenewalDemoAIBubble } from './RenewalDemoAIBubble';

export default function RenewalDemoButton() {
  const { anchorEl, isMenuOpen, openMenu, closeMenu } = useOptionsMenu();
  const [renderedSteps, setRenderedSteps] = useState<Set<number>>(new Set());
  const [isPaused, { toggle: togglePause, on: setPaused }] = useBoolean(false);

  const onStepRendered = (stepIndex: number) => {
    setRenderedSteps((prev) => new Set([...Array.from(prev), stepIndex]));
  };

  const onClose = () => {
    setPaused();
    closeMenu();
  };

  const { demoSteps, isLoading } = useGetRenewalDemoSteps({
    onClose,
  });

  const buttonText = useMemo(() => {
    if (renderedSteps.size === 0) {
      return 'Initiate Renewal';
    }

    if (renderedSteps.size < demoSteps.length && !isMenuOpen) {
      return 'Continue Renewal';
    }

    if (isMenuOpen) {
      return 'Close';
    }

    return 'View summary';
  }, [renderedSteps, isMenuOpen, demoSteps.length]);

  return (
    <>
      <Button variant="outlined" size="small" onClick={openMenu}>
        {buttonText}
      </Button>
      {isMenuOpen && (
        <RenewalDemoAIBubble
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={onClose}
          renderedSteps={renderedSteps}
          onStepRendered={onStepRendered}
          isPaused={isPaused}
          togglePause={togglePause}
          demoSteps={demoSteps}
          isLoading={isLoading}
        />
      )}
    </>
  );
}
